import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/page/HelloWorld'
// 登录
import Login from '@/page/login'
// 主页
import Index from '@/page/index'
// 债权悬赏
import Assignment from '@/page/Assignment'
// 法院专栏
import Court from '@/page/court'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },{
      path: '/index',
      name: 'index',
      component: Index
    },{
      path: '/Assignment',
      name: 'Assignment',
      component: Assignment
    },{
      path: '/court',
      name: 'court',
      component: Court
    },{
      path:'/test',
      name: 'helloWorld',
      component: HelloWorld
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js